import { Avatar, WindmillContext } from "@windmill/react-ui";
import Cookies from "js-cookie";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import {
  IoClose,
  IoGridOutline,
  IoLogOutOutline,
  // IoMenu,
  IoMoonSharp,
  IoNotificationsSharp,
  IoSettingsOutline,
  IoSunny,
} from "react-icons/io5";
import { Link } from "react-router-dom";
import noNotification from "../../assets/img/no-notification.svg";
//internal import
// import cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { AdminContext } from "context/AdminContext";
import { SidebarContext } from "context/SidebarContext";
// import { SidebarContext } from "context/SidebarContext";
import { emptySetting } from "redux/Actions/SettingActions";
import { emptySideBarMenu } from "redux/Actions/SideBarActions";
import drakLogo from "../../assets/img/logo/logo-dark.svg";
import lightLogo from "../../assets/img/logo/logo-light.svg";
import { NavLink, useHistory } from "react-router-dom/cjs/react-router-dom.min";

const Header = () => {
  const reduxDisPatch = useDispatch();
  // const { toggleSidebar, setNavBar, navBar } = useContext(SidebarContext);
  const { state, dispatch } = useContext(AdminContext);
  const { notification } = useContext(SidebarContext);
  const { adminInfo } = state;
  const history = useHistory();
  const { mode, toggleMode } = useContext(WindmillContext);
  const [profileOpen, setProfileOpen] = useState(false);
  const [notificationOpen, setNotificationOpen] = useState(false);
  const pRef = useRef();
  const nRef = useRef();
  const { t } = useTranslation();
  const handleLogOut = () => {
    dispatch({ type: "USER_LOGOUT" });
    Cookies.remove("adminInfo");
    localStorage.removeItem("adminInfo");
    localStorage.removeItem("authTime")
    reduxDisPatch(emptySideBarMenu());
    reduxDisPatch(emptySetting());
    // window.location.replace(`http://localhost:4009/login`);
    //window.location.replace(`http://${process.env.REACT_APP_ADMIN_DOMAIN}/login`);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!pRef?.current?.contains(e.target)) {
        setProfileOpen(false);
      }
      if (!nRef?.current?.contains(e.target)) {
        setNotificationOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
  }, [pRef, nRef]);

  // const handleNotificationOpen = () => {
  //   setNotificationOpen(!notificationOpen);
  //   setProfileOpen(false);
  // };

    const handleNotificationOpen = () => {
    history.push('/notifications')
  };


  const handleProfileOpen = () => {
    setProfileOpen(!profileOpen);
    setNotificationOpen(false);
  };

  // const onChange = (event) => {
  //     i18next.changeLanguage(event.target.value);

  // }

  return (
    <>
      <header className="z-30 py-4 bg-white shadow-sm dark:bg-gray-800">
        <div className="flex items-center justify-between h-full px-6 mx-auto text-green-500 dark:text-green-500">
          <NavLink to={"/dashboard"} className="logo-details">
            <img
              src={mode === "dark" ? drakLogo : lightLogo}
              className="mainIcon small"
              alt="B2bLogo"
            />
          </NavLink>

          <ul className="flex justify-end items-center flex-shrink-0 space-x-6">
            {/* <!-- Theme toggler --> */}

            <li className="flex">
              <button
                className="rounded-md focus:outline-none"
                onClick={toggleMode}
                aria-label="Toggle color mode"
              >
                {mode === "dark" ? (
                  <IoSunny className="w-5 h-5" aria-hidden="true" />
                ) : (
                  <IoMoonSharp className="w-5 h-5" aria-hidden="true" />
                )}
              </button>
            </li>

            {/* <!-- Notifications menu --> */}

            {/* <!-- Notifications menu --> */}
            <li className="relative inline-block text-left" ref={nRef}>
              <button
                className="relative align-middle rounded-md focus:outline-none"
                onClick={handleNotificationOpen}
              >
                <IoNotificationsSharp className="w-5 h-5" aria-hidden="true" />
                {/* {notification.filter((n) => n.status === 0).length > 0 ? (
                  <span className="absolute z-10 top-0 right-0 inline-flex items-center justify-center p-0.5 h-4 w-4 text-xs font-medium leading-none text-red-100 transform -translate-x-1/2 -translate-y-1/2 bg-red-500 rounded-full">
                    {notification.filter((n) => n.status === 0).length}
                  </span>
                ) : null} */}

              </button>



              {/* <li className="relative inline-block text-left" ref={nRef}>
              <button
                className="relative align-middle rounded-md focus:outline-none"
                onClick={handleNotificationOpen}
              >
                <IoNotificationsSharp className="w-5 h-5" aria-hidden="true" />
                {notification.filter((n) => n.status === 0).length > 0 ? (
                  <span className="absolute z-10 top-0 right-0 inline-flex items-center justify-center p-1 h-5 w-5 text-xs font-medium leading-none text-red-100 transform -translate-x-1/2 -translate-y-1/2 bg-red-500 rounded-full">
                  {notification.filter((n) => n.status === 0).length}
                </span>
                ): null}
                
              </button>

              {notificationOpen && (
                <div className="origin-top-right absolute right-0 mt-2 rounded-md shadow-lg bg-white dark:bg-gray-700 ring-1 ring-black ring-opacity-5 focus:outline-none overflow-hidden">
                  <div className="notification-box">
                    <Scrollbars>
                      {notification?.length > 0 ? (
                        <ul className="block text-sm border-t border-gray-100 dark:border-gray-700 rounded-md">
                          {notification
                            .slice(-5)
                            .reverse()
                            .map((notification, index) => (
                              <li
                                key={index}
                                className="flex justify-between items-center font-serif font-normal text-sm py-3 border-b border-gray-100 dark:border-gray-700 px-3 transition-colors duration-150 hover:bg-gray-50 dark:text-gray-400 dark:hover:bg-gray-900 dark:hover:text-gray-100 cursor-pointer"
                              >
                                <div className="flex items-center">
                                  <div className="notification-content">
                                    <h6 className="font-medium text-gray-500">
                                      {notification.message}
                                    </h6>

                                    <p className="text-xs text-gray-400">
                                      {notification.sent_time}
                                    </p>
                                  </div>
                                </div>

                                <span className="px-2 hover:text-gray-800 dark:hover:text-gray-200">
                                  <IoClose />
                                </span>
                              </li>
                            ))}
                        </ul>
                      ) : (
                        <div className="noNotification">
                          <img src={noNotification} alt="" />
                          No new Notifications
                        </div>
                      )}
                    </Scrollbars>

                    {notification?.length > 0 ? (
                      <div
                        className="absolute bottom-0 bg-white dark:bg-gray-600 dark:text-gray-100 py-2 px-5 text-right"
                        style={{ width: "100%" }}
                      >
                        <button
                          className="mx-auto "
                          onClick={() => {
                            history.push("/notification");
                            handleNotificationOpen();
                          }}
                        >
                          View more..
                        </button>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              )}

              {/* {notificationOpen && (
                <div className="origin-top-right absolute right-0 mt-2 rounded-md shadow-lg bg-white dark:bg-gray-800 ring-1 ring-black ring-opacity-5 focus:outline-none">
                  <div className="notification-box bg-white dark:bg-gray-500">
                    <Scrollbars>
                      <ul className="block text-sm border-t border-gray-100 dark:border-gray-700 rounded-md">
                        {notification
                          .slice(-5)
                          .reverse()
                          .map((notification, index) => (
                            <>
                              <li
                                key={index}
                                className="flex justify-between items-center font-serif font-normal text-sm py-3 border-b border-gray-100 dark:border-gray-700 px-3 transition-colors duration-150 hover:bg-gray-50 hover:text-gray-800 dark:text-gray-400 dark:hover:bg-gray-900 dark:hover:text-gray-100 cursor-pointer"
                              >
                                <div className="flex items-center">
                                  <div className="notification-content">
                                    <h6 className="font-medium text-gray-500">
                                      <div>{notification.message}</div>
                                    </h6>

                                    <p className="flex items-center text-xs text-gray-400">
                                      <span className="ml-2">
                                        {notification.sent_time}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              </li>
                            </>
                          ))}
                      </ul>
                      {notification?.length > 0 ? (
                        <div>
                          <button
                            onClick={() => {
                              history.push("/notification");
                              handleNotificationOpen();
                            }}
                          >
                            View More
                          </button>
                        </div>
                      ) : (
                        <>No new Notifications</>
                      )}
                    </Scrollbars>
                  </div>
                </div>
              )} */}
            </li>

            {/* <!-- Profile menu --> */}
            <li className="relative inline-block text-left" ref={pRef}>
              <button
                className="rounded-full dark:bg-gray-500 bg-green-500 text-white h-8 w-8 font-medium mx-auto focus:outline-none"
                onClick={handleProfileOpen}
              >
                {adminInfo.image ? (
                  <Avatar
                    className="align-middle"
                    src={`${adminInfo.image}`}
                    aria-hidden="true"
                  />
                ) : (
                  <span>{adminInfo.email[0].toUpperCase()}</span>
                )}
              </button>

              {profileOpen && (
                <ul className="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white dark:bg-gray-800 ring-1 ring-black ring-opacity-5 focus:outline-none">
                  <li className="justify-between font-serif font-medium py-2 pl-4 transition-colors duration-150 hover:bg-gray-100 text-gray-500 hover:text-green-500 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200">
                    <Link to="/dashboard">
                      <span className="flex items-center text-sm">
                        <IoGridOutline
                          className="w-4 h-4 mr-3"
                          aria-hidden="true"
                        />
                        <span>{t("Dashboard")}</span>
                      </span>
                    </Link>
                  </li>

                  <li className="justify-between font-serif font-medium py-2 pl-4 transition-colors duration-150 hover:bg-gray-100 text-gray-500 hover:text-green-500 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200">
                    <Link to="/edit-profile">
                      <span className="flex items-center text-sm">
                        <IoSettingsOutline
                          className="w-4 h-4 mr-3"
                          aria-hidden="true"
                        />
                        <span>{t("EditProfile")}</span>
                      </span>
                    </Link>
                  </li>

                  <li
                    onClick={handleLogOut}
                    className="cursor-pointer justify-between font-serif font-medium py-2 pl-4 transition-colors duration-150 hover:bg-gray-100 text-gray-500 hover:text-green-500 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200"
                  >
                    <span className="flex items-center text-sm">
                      <IoLogOutOutline
                        className="w-4 h-4 mr-3"
                        aria-hidden="true"
                      />
                      <span>{t("LogOut")}</span>
                    </span>
                  </li>
                </ul>
              )}
            </li>
          </ul>
        </div>
      </header>
    </>
  );
};

export default Header;
